import { useMemo } from 'react';

import useFetchSystemTemplates from 'components/domain/automation/systemTemplates/useFetchSystemTemplates';
import { SystemTemplateRow } from '../../SystemTemplatesTab.types';

/**
 * Returns only the system templates that were able to be fetched from the API.
 */
const useVisibleSystemTemplateRows = (rows: SystemTemplateRow[]) => {
  const { data: systemTemplates, isLoading } = useFetchSystemTemplates();

  const visibleRows = useMemo(() => {
    if (!systemTemplates) {
      return [];
    }

    const visibleKeys = new Set(
      systemTemplates.map((template) => template.key),
    );
    return rows.filter((row) => visibleKeys.has(row.key));
  }, [rows, systemTemplates]);

  return { rows: visibleRows, isLoading };
};

export default useVisibleSystemTemplateRows;
